import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function () {
  const heroSlideshow = $('.block-hero__slideshow');
  heroSlideshow.slick({
    dots: false,
    infinite: true,
    fade: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: true,
        },
      },
    ],
  });

  const arrowSlideshow = document.querySelectorAll('.slideshow-arrow');
  const counterCurrent = document.querySelector('.counter-current');

  arrowSlideshow.forEach((arrow) => {
    arrow.addEventListener('click', function () {
      heroSlideshow.on('afterChange', function (event, slick, currentSlide) {
        counterCurrent.textContent = currentSlide + 1;
      });

      if (arrow.classList.contains('left')) {
        heroSlideshow.slick('slickPrev');
      } else {
        heroSlideshow.slick('slickNext');
      }
    });
  });
});
